import React, { useEffect, useRef, useState } from 'react'
import Form from 'react-bootstrap/Form';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { faker } from '@faker-js/faker';
import { Doughnut } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { UserAuth } from '../../auth/Auth';
import { PrivateAxios, url } from '../../../environment/AxiosInstance';
import { useReactToPrint } from 'react-to-print';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { process } from '@progress/kendo-data-query';
import "../TaskReport/report.min.css"
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { ErrorMessage } from '../../../environment/ToastMessage';
import { calculateDelayInHoursEndTime, isURL } from '../../../environment/Helper';
import moment from 'moment';
import './checksheetReport.css';


ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);
const optionsChecksheet = {
    responsive: true,
    plugins: {
        legend: {
            display: true,
            position: 'bottom',
            labels: {
                color: '#9e9e9e',
                align: 'start', // Left-align the labels
                usePointStyle: true,
                padding: 10,
            },
        },
        // title: {
        //     display: true,
        //     fontSize: 20,
        //     text: 'Checksheet'
        // }
    },
    cutout: '60%',
}


const generateDateRange = (startDate, endDate) => {
    const dates = [];
    let current = new Date(startDate);
    const end = new Date(endDate);
    while (current <= end) {
        dates.push(current.toISOString().split('T')[0]);
        current.setDate(current.getDate() + 1);
    }
    return dates;
};



function ChecksheetReportIndex() {

    const { User, MDExist, userDetails, AdminExist } = UserAuth();
    const currentDate = new Date();
    const startDateInput = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    const endDateInput = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

    const [TaskData, setTaskData] = useState({
        "startDate": startDateInput,
        "endDate": endDateInput,
        "doer_id": "",
        "pie": 0,
        "chat": 0,
    })
    const [reportData, setReportData] = useState([])
    const [modifyData, setModifyData] = useState([])
    const [UserName, setUserName] = useState('')
    const [dateRange, setDateRange] = useState({
        "startDate": "",
        "endDate": ""
    })

    const GetReport = (data) => {
        PrivateAxios.post('report/dynamic/sheet-report', data)
            .then((res) => {

                const filteredTask = res.data.data[0].task?.filter((item) => item.status != 4);
                setUserName(res.data.data[0].userId);
                setReportData(filteredTask);
                setDateRange({ ...dateRange, startDate: res.data.startDate, endDate: res.data.endDate })

                const groupedData = [];
                if (filteredTask?.length > 0) {
                    filteredTask.forEach(item => {
                        const name = item.checkSheetList.name;
                        const existingGroup = groupedData.find(group => group.name === name);

                        const entry = {
                            due_date: new Date(item.due_date).toISOString().split('T')[0],
                            planned_date: item.due_date,
                            completed_date: item.completed_date,
                            status: item.status
                        };

                        if (existingGroup) {
                            existingGroup.items.push(entry);
                        } else {
                            groupedData.push({
                                name,
                                items: [entry]
                            });
                        }
                    });
                }
                setModifyData(groupedData)

            }).catch((err) => {
                if (err?.response?.data?.status == false) {
                    ErrorMessage(err?.response?.data?.message)
                }

            })

    }

    const GetReportData = (e) => {
        e.preventDefault();
        GetReport(TaskData)
    }


    // const labels = reportData.map(item => `${User.find(data => data.id == item.userId)?.name}`);

    // const data = {
    //     labels,
    //     datasets: [
    //         {
    //             label: 'Total Task',
    //             data: reportData.map(item => item.total),
    //             backgroundColor: 'rgb(97, 97, 255)',
    //         },
    //         {
    //             label: 'Pending Task',
    //             data: reportData.map(item => item.pending),
    //             backgroundColor: 'rgb(223, 47, 74)',
    //         },
    //         {
    //             label: 'Completed Task',
    //             data: reportData.map(item => item.complete),
    //             backgroundColor: 'rgb(0, 200, 117)',
    //         },
    //         {
    //             label: 'To DO Task',
    //             data: reportData.map(item => item.todo),
    //             backgroundColor: '#747373',
    //         },
    //         {
    //             label: 'Inprogress Task',
    //             data: reportData.map(item => item.inprogress),
    //             backgroundColor: 'rgb(254, 171, 61)',
    //         },
    //     ],
    // };


    const BarData = {
        labels: [
            'Pending Task',
            'Completed Task',
            'To Be Completed Task',
            'Delay Completed Task',
        ],
        datasets: [
            {
                data: [
                    reportData.filter(item => item.status != 4 && item.completed_date == null && calculateDelayInHoursEndTime(item.due_date, TaskData.endDate) != "0:00").length || 0,
                    reportData.filter(item => item.status != 4 && item.completed_date && calculateDelayInHoursEndTime(item.due_date, item.completed_date) == '0:00').length || 0,
                    reportData.filter(item => item.status != 4 && item.completed_date == null && calculateDelayInHoursEndTime(item.due_date, TaskData.endDate) == "0:00").length || 0,
                    reportData.filter(item => item.status != 4 && item.completed_date && calculateDelayInHoursEndTime(item.due_date, item.completed_date) != "0:00").length || 0
                ],
                backgroundColor: [
                    'rgb(229, 222, 39)',
                    'rgb(16, 148, 6)',
                    'rgb(89, 71, 208)',
                    'rgb(244, 27, 27)',
                ],
                borderWidth: 0,
            },
        ],
    };

    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({ contentRef });
    //dark theme select
    const [isDarkTheme, setIsDarkTheme] = useState(false);

    // Check for the theme by looking at the body's class list
    useEffect(() => {
        const checkTheme = () => {
            setIsDarkTheme(document.body.classList.contains("dark-theme"));
        };

        // Initial check
        checkTheme();

        // MutationObserver to detect theme changes on body
        const observer = new MutationObserver(checkTheme);
        observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });

        // Clean up observer on component unmount
        return () => observer.disconnect();
    }, []);
    //dark theme select end

    const [hide, setHide] = useState(false);
    //custom range select
    const [selectedRange, setSelectedRange] = useState('3m'); // Default selection
    const [fmsData, setFmsData] = useState({ startDate: null, endDate: null });
    const handleRadioChange = (event) => {
        setSelectedRange(event.target.value);
    };


    //=======================Date Range==========================//
    const dateColumns = generateDateRange(dateRange.startDate, dateRange.endDate);

    return (
        <React.Fragment>
            <div className="p-4 checksheet-report-container" ref={contentRef}>
                <div className="mb-4 d-flex align-items-center justify-content-betweem">
                    <Link className="text-dark back-btn me-3" to="/reports">
                        <i className="fas fa-long-arrow-alt-left me-1" />Back
                    </Link>
                </div>
                <div className="container-fluid px-0">
                    <div className="row">
                        <div className="col-12">
                            <form className='card mb-4 checksheet-report-filter-card' onSubmit={GetReportData}>
                                <div className="card-header">
                                    <h3 className="card-title">Repeat Task Report</h3>
                                </div>
                                <div className='card-body pb-1'>
                                    <div className='w-100'>
                                        <div className='row'>

                                            <div className='col-xl-6 col-md-12 col-12'>
                                                <div className='form-group'>
                                                    <label className='form-label'>Doer Name <span className='text-exp-red'>*</span></label>
                                                    <div className='custom-select-wrap multi-select'>
                                                        <Select
                                                            required
                                                            name='doerName'
                                                            options={MDExist || AdminExist ? User : userDetails.branch_position == "HOD" ? User.filter(item => item.departments_id == userDetails.departments_id && item.branch_id == userDetails.branch_id) : User.filter(item => item.id == userDetails.id)}
                                                            getOptionLabel={(option) => option.name}
                                                            getOptionValue={(option) => option.id}
                                                            // isMulti
                                                            theme={(theme) => ({
                                                                ...theme,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: '#ddddff',
                                                                    primary: '#6161ff',
                                                                },
                                                            })}
                                                            onChange={(data) => {
                                                                const MultiDoers = JSON.stringify([data.id]);
                                                                setTaskData({ ...TaskData, doer_id: MultiDoers })
                                                            }}
                                                            styles={{
                                                                menu: (base) => ({
                                                                    ...base,
                                                                    backgroundColor: isDarkTheme ? "#06162f" : "#ffffff",
                                                                    color: isDarkTheme ? "#e0e0e0" : "#000000",
                                                                }),
                                                                singleValue: (base) => ({
                                                                    ...base,
                                                                    color: isDarkTheme ? "#e0e0e0" : "#000000",
                                                                }),
                                                                option: (base, state) => ({
                                                                    ...base,
                                                                    backgroundColor: state.isFocused ? (isDarkTheme ? "#112a46" : "#ddddff") : "transparent",
                                                                    color: isDarkTheme ? "#e0e0e0" : "#000000",
                                                                }),
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-lg-3 col-md-6 col-12'>
                                                <div className='form-group'>
                                                    <label className='form-label'>From <span className='text-exp-red'>*</span></label>
                                                    <div className="exp-datepicker-cont">
                                                        <span className="cal-icon"><i class="fas fa-calendar-alt" /></span>
                                                        <DatePicker
                                                            required
                                                            selected={TaskData.startDate} onChange={(date) => setTaskData({ ...TaskData, startDate: date })}
                                                            dateFormat="dd/MM/YYYY"
                                                            placeholderText='Select Date'
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-lg-3 col-md-6 col-12'>
                                                <div className='form-group'>
                                                    <label className='form-label'>To <span className='text-exp-red'>*</span></label>
                                                    <div className="exp-datepicker-cont">
                                                        <span className="cal-icon"><i class="fas fa-calendar-alt" /></span>
                                                        <DatePicker
                                                            required
                                                            selected={TaskData.endDate} onChange={(date) => setTaskData({ ...TaskData, endDate: date })}
                                                            dateFormat="dd/MM/YYYY"
                                                            placeholderText='Select Date'
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-12'>
                                                <div className='form-group mb-1'>
                                                    <div className='d-flex flex-wrap'>
                                                        {/* <label className="custom-checkbox me-4">
                                                Bar Chart

                                                <input
                                                    type="checkbox"
                                                    name="workflow"
                                                    checked={TaskData.pie === 1}
                                                    onChange={(e) => setTaskData({ ...TaskData, pie: e.target.checked ? 1 : 0 })}
                                                />
                                                <span className="checkmark" />
                                            </label>
                                            {hide ? "" : */}
                                                        <label className="custom-checkbox me-4">
                                                            Pie Chart
                                                            <input
                                                                type="checkbox"
                                                                name="checksheet"
                                                                checked={TaskData.chat === 1}
                                                                onChange={(e) => setTaskData({ ...TaskData, chat: e.target.checked ? 1 : 0 })}
                                                            />
                                                            <span className="checkmark" />
                                                        </label>
                                                        {/* } */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer d-flex justify-content-end">
                                    <button type="reset" name="reset_button" className="btn btn-exp-light me-2">Reset</button>
                                    <button type="submit" name="submit_button" className="btn btn-exp-green">Generate Report</button>
                                </div>
                            </form>
                            <div className="row">
                                {!reportData.length > 0 ?
                                    <div className="col-12">
                                        <div className="card bg-warning-light mb-0">
                                            <div className="card-body">
                                                <div className="exp-no-data-found text-exp-red">
                                                    <img className="task-img mb-3" src={process.env.PUBLIC_URL + 'assets/images/search-no-record-found.webp'} alt="No task" />
                                                    <h6>No Record Found</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div> :
                                    <div className={`${TaskData.chat == 1 ? 'col-lg-8' : 'col-lg-12'} col-md-12`}>
                                        <div className='d-flex justify-content-end mb-3'>
                                            <button className='btn btn-secondary btn-sm' onClick={reactToPrintFn}>
                                                <i className="fas fa-print me-2"></i>
                                                Print
                                            </button>
                                        </div>
                                        {reportData.length > 0 ?
                                            <div className='card rounded-10 overflow-hidden mb-4'>
                                                <div className='card-header border-bottom-0 d-flex align-items-center justify-content-between gap-3 flex-wrap'>
                                                    {User && User.map((item) => (
                                                        item.id == UserName ?
                                                            < div className="profile-wrap" key={item.id}>
                                                                <div className="exp-avtar bg-exp-yellow">
                                                                    {item.user_photo != null ?
                                                                        < img className="prof-img" src={isURL(item.user_photo) ? item.user_photo : url + item.user_photo} alt="user" /> :
                                                                        <span>{item.name != '' ? item.name.split(' ').length > 1 ? item.name.split(' ')[0].split('')[0] + item.name.split(' ')[1].split('')[0] : item.name.split('')[0] + item.name.split('')[1] : ""}</span>
                                                                    }
                                                                </div>
                                                                <div className="ps-2 profile-name-wrap text-truncate">
                                                                    <h5 className="profile-name text-nowrap text-truncate">{item.name}</h5>
                                                                </div>
                                                            </div> : ""
                                                    ))
                                                    }
                                                    <div className='CheckReport_status_bar d-flex flex-wrap gap-2 ms-auto'>
                                                        <div className='d-flex align-items-center gap-1 fw-medium'>
                                                            <span className='badge badge-success w-20 h-20'>C</span> Completed
                                                        </div>
                                                        <div className='d-flex align-items-center gap-1 fw-medium'>
                                                            <span className='badge badge-primary w-20 h-20'>TC</span> To be Completed
                                                        </div>
                                                        <div className='d-flex align-items-center gap-1 fw-medium'>
                                                            <span className='badge badge-warning w-20 h-20'>P</span> Pending
                                                        </div>
                                                        <div className='d-flex align-items-center gap-1 fw-medium'>
                                                            <span className='badge badge-danger w-20 h-20'>DC</span> Delay Completed
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='card-body p-0'>
                                                    <div className='table-responsive'>
                                                        <Grid
                                                            data={modifyData}
                                                            style={{ width: '100%', minWidth: '800px' }}
                                                            className='kendo-table-border-block report_kendo_table'
                                                        >
                                                            <GridColumn
                                                                field="id"
                                                                title="#"
                                                                width="40px"
                                                                headerClassName="fw-bold"
                                                            />
                                                            <GridColumn
                                                                title="Task Name"
                                                                width="250px"
                                                                headerStyle={{ minWidth: '250px' }}
                                                                cellStyle={{ minWidth: '250px' }}
                                                                headerClassName="fw-bold"
                                                                cell={(props) => (
                                                                    <td>
                                                                        <div><span className='fw-bold'>{props.dataItem.name}</span></div>
                                                                    </td>
                                                                )}
                                                            />

                                                            {/* Generate columns for days 1-31 */}
                                                            {dateColumns.map(day => (
                                                                <GridColumn
                                                                    key={day}
                                                                    title={day.toString()}
                                                                    width="140px"
                                                                    headerStyle={{ minWidth: '50px' }}
                                                                    cellStyle={{ minWidth: '50px' }}
                                                                    headerClassName="fw-bold justify-content-center"
                                                                    cell={(props) => (
                                                                        <td>
                                                                            <div>
                                                                                {/* You'll need to adjust this logic based on how your data is structured */}
                                                                                {props.dataItem.items && (
                                                                                    props.dataItem.items.find(item => item.due_date == day && item.completed_date && calculateDelayInHoursEndTime(item.planned_date, item.completed_date) == '0:00') ? (
                                                                                        <OverlayTrigger
                                                                                            trigger="hover"
                                                                                            rootClose
                                                                                            placement="top"
                                                                                            overlay={
                                                                                                <Popover id="my-kpi-help" className="unique-outer-wrap">
                                                                                                    <div className="unique-outer-wrap p-3">
                                                                                                        <p className='mb-0'>
                                                                                                            Completed Date : {props.dataItem.items.find(item => item.due_date == day).completed_date}
                                                                                                        </p>
                                                                                                    </div>
                                                                                                </Popover>
                                                                                            }
                                                                                        >
                                                                                            <span className='badge badge-success w-20 h-20'>C</span>
                                                                                        </OverlayTrigger>
                                                                                    ) : props.dataItem.items.find(item => item.due_date == day && item.completed_date == null && calculateDelayInHoursEndTime(item.planned_date, new Date()) != '0:00') ? (
                                                                                        <span className='badge badge-warning w-20 h-20'>P</span>
                                                                                    ) : props.dataItem.items.find(item => item.due_date == day && item.completed_date == null && calculateDelayInHoursEndTime(item.planned_date, new Date()) == '0:00') ? (
                                                                                        <span className='badge badge-primary w-20 h-20'>TC</span>
                                                                                    ) : props.dataItem.items.find(item => item.due_date == day && item.completed_date && calculateDelayInHoursEndTime(item.planned_date, item.completed_date) != '0:00') ? (
                                                                                        <OverlayTrigger
                                                                                            trigger="hover"
                                                                                            rootClose
                                                                                            placement="top"
                                                                                            overlay={
                                                                                                <Popover id="my-kpi-help" className="unique-outer-wrap">
                                                                                                    <div className="unique-outer-wrap p-3">
                                                                                                        <p className='mb-0'>
                                                                                                            Completed Date : {moment(props.dataItem.items.find(item => item.due_date == day).completed_date).format("DD-MM-YYYY h:mm A")}
                                                                                                        </p>
                                                                                                        <p className='mb-0'>
                                                                                                            Delay Hours : {calculateDelayInHoursEndTime(props.dataItem.items.find(item => item.due_date == day).planned_date, props.dataItem.items.find(item => item.due_date == day).completed_date)} hrs
                                                                                                        </p>
                                                                                                    </div>
                                                                                                </Popover>
                                                                                            }
                                                                                        >
                                                                                            <span className='badge badge-danger w-20 h-20'>DC</span>
                                                                                        </OverlayTrigger>
                                                                                    ) : (
                                                                                        <span className='w-20 h-20'>-</span>
                                                                                    )
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                    )}
                                                                />
                                                            ))}
                                                        </Grid>
                                                    </div>
                                                </div>
                                            </div> : ""
                                        }
                                    </div>
                                }
                                {reportData.length > 0 ?
                                    <>
                                        {/* {
                                TaskData.pie == 1 ?
                                    <div className={`${hide ? 'col-lg-12' : 'col-lg-8'} col-md-12`}>
                                        <div className='card'>
                                            <div className='card-body'>
                                                <div className='overflow-x-scroll'>
                                                    <div className='bar-card-report'>
                                                        <Bar data={data} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> : ""
                            } */}
                                        {TaskData.chat == 1 ?
                                            <div className='col-lg-4 col-md-6'>
                                                <div className='card'>
                                                    <div className='card-body'>
                                                        <Doughnut data={BarData} options={optionsChecksheet} />
                                                    </div>
                                                </div>
                                            </div> : ""
                                        }
                                    </> : ""
                                }
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </React.Fragment>
    )
}

export default ChecksheetReportIndex